import { Controller } from "stimulus"
import TomSelect from "tom-select/dist/esm/tom-select.complete.js";

export default class extends Controller {
  connect() {
    new TomSelect(this.element)
  }
}
